import { ComponentProps } from 'react';
import useIsIos from '@alltrails/core/hooks/useIsIos';
import InstallInterstitial from './InstallInterstitial';

type Props = ComponentProps<typeof InstallInterstitial>;

// Design link: https://www.figma.com/file/oevB4bXh8KLLDe1Yp8rBW2?type=design%27&node-id=11925:74124

export default function InstallInterstitialWrapper(props: Props) {
  const isIos = useIsIos();

  if (isIos) {
    return null;
  }

  return <InstallInterstitial {...props} />;
}
